// Costanti
const CLASSES = {
  TRIGGER: 'scroll-trigger',
  OFFSCREEN: 'scroll-trigger--offscreen',
  ZOOM_IN: 'animate--zoom-in',
  CANCEL: 'scroll-trigger--cancel',
  DESIGN_MODE: 'scroll-trigger--design-mode'
};

// Funzioni di utilità
const throttle = (func, limit = 250) => {
  let lastFunc, lastRan;
  return function(...args) {
    if (!lastRan) {
      func.apply(this, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(() => {
        if (Date.now() - lastRan >= limit) {
          func.apply(this, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
};

const percentageSeen = (element) => {
  const { top, height } = element.getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  if (top > viewportHeight) return 0;
  if (top + height <= 0) return 100;
  const distance = viewportHeight - top;
  return Math.round((distance / (viewportHeight + height)) * 100);
};

// Logica di animazione dello scorrimento
const handleIntersection = (entries, observer) => {
  entries.forEach((entry, index) => {
    const target = entry.target;
    if (entry.isIntersecting) {
      target.classList.remove(CLASSES.OFFSCREEN);
      if (target.hasAttribute('data-cascade')) {
        target.style.setProperty('--animation-order', index);
      }
      observer.unobserve(target);
    } else {
      target.classList.add(CLASSES.OFFSCREEN);
      target.classList.remove(CLASSES.CANCEL);
    }
  });
};

const initScrollAnimation = (rootEl = document, isDesignMode = false) => {
  const triggers = rootEl.getElementsByClassName(CLASSES.TRIGGER);
  if (!triggers.length) return;

  if (isDesignMode) {
    Array.from(triggers).forEach(el => el.classList.add(CLASSES.DESIGN_MODE));
    return;
  }

  const observer = new IntersectionObserver(handleIntersection, {
    rootMargin: '0px 0px -50px 0px'
  });

  Array.from(triggers).forEach(el => observer.observe(el));
};

// Logica di animazione dello zoom
const initZoomAnimation = () => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const zoomElements = document.getElementsByClassName(CLASSES.ZOOM_IN);
  if (!zoomElements.length) return;

  const scaleAmount = 0.002;
  const updateZoom = throttle(() => {
    Array.from(zoomElements).forEach(el => {
      if (el.isVisible) {
        el.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(el));
      }
    });
  });

  Array.from(zoomElements).forEach(el => {
    el.isVisible = false;
    new IntersectionObserver(([entry]) => {
      el.isVisible = entry.isIntersecting;
    }).observe(el);
  });

  window.addEventListener('scroll', updateZoom, { passive: true });
};

// Inizializzazione
const init = () => {
  initScrollAnimation();
  initZoomAnimation();
};

window.addEventListener('DOMContentLoaded', init);

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', event => initScrollAnimation(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initScrollAnimation(document, true));
}